const meta = {
  licensing: 'Licensing',
  limits: 'Limits',
  definitions: 'Definitions',
};

export default meta;
